(() => {
  const configNode = document.getElementById('fitorb-us-navigation-config');
  if (!configNode || !['fitorb.shop', 'www.fitorb.shop'].includes(location.hostname)) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  if (config.country !== 'US' || config.locale !== 'en') return;
  const hosts = new Set(['fitorb.shop', 'www.fitorb.shop', 'fitorb.de', 'www.fitorb.de', 'fitorb.nl', 'www.fitorb.nl']);
  function localize(value) {
    if (!value || /^(#|mailto:|tel:|javascript:)/i.test(value)) return value;
    let url;
    try { url = new URL(value, location.href); } catch { return value; }
    if (!/^https?:$/.test(url.protocol) || !hosts.has(url.hostname)) return value;
    let path = url.pathname.replace(/^\/(de|nl|en|es|fr|it)(?=\/|$)/, '') || '/';
    if (!/^\/(?:$|products\/|collections\/|pages\/|policies\/|blogs\/|search(?:\/|$)|cart(?:\/|$))/.test(path)) return value;
    if (/^\/products\/fitorb-smart-ring-pro\/?$/.test(path)) path = '/products/fitorb-smart-ring-pro-3';
    url.searchParams.set('country', 'US');
    return `/${config.locale}${path}${url.search}${url.hash}`;
  }
  function update(anchor) {
    if (!(anchor instanceof HTMLAnchorElement) || anchor.hasAttribute('hreflang') || anchor.hasAttribute('download')) return;
    const old = anchor.getAttribute('href');
    const next = localize(old);
    if (next !== old) anchor.setAttribute('href', next);
  }
  function scan(root) {
    if (root instanceof HTMLAnchorElement) update(root);
    if (root.querySelectorAll) root.querySelectorAll('a[href]').forEach(update);
  }
  scan(document);
  document.addEventListener('pointerdown', event => update(event.target.closest?.('a[href]')), true);
  document.addEventListener('click', event => update(event.target.closest?.('a[href]')), true);
  new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'attributes') update(record.target);
      else record.addedNodes.forEach(scan);
    });
  }).observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['href']});
})();
